/**
 * Read the CSRF token from the XSRF-TOKEN cookie (set by Rails on every response).
 * Falls back to the <meta name="csrf-token"> tag for the initial page load.
 */
export function getCsrfToken(): string {
  const match = document.cookie.match(/XSRF-TOKEN=([^;]+)/)
  if (match) return decodeURIComponent(match[1])

  return document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')?.content || ''
}

/** Standard headers for JSON fetch requests with CSRF protection. */
export function jsonCsrfHeaders(): Record<string, string> {
  return { 'Content-Type': 'application/json', 'X-CSRF-Token': getCsrfToken() }
}

/** CSRF-only header (no Content-Type) for FormData/non-JSON requests. */
export function csrfHeader(): Record<string, string> {
  return { 'X-CSRF-Token': getCsrfToken() }
}
